module.exports = __webpack_public_path__ + "static/img/avatar-s-24.61de186b.jpg";